module.exports = __webpack_public_path__ + "static/media/yes.0700bd11.mp3";